import * as React from 'react';
import { ICardAssigneesProps } from './types';
import {
    CARD_ACTIONS_PORTAL,
    CARD_CLASS,
    CARD_CONTROL_CLASS,
    CARD_TEMPLATES_PORTAL,
    DEFAULT_PORTAL, LIST_CONTROL_CLASS
} from '../../../../constants';
import './_CardAssignees.scss';
import { UsersTooltip } from '../../../../../../base/components/UsersTooltip/UsersTooltip';
import { Button, ButtonDropdown, Icon } from 'kui';
import { CLASS_ABSTRACT_DASHBOARD_SCROLL_PREVENT } from '../../../../../../../abstracts/constants';
import { TOP_BAR_CLASS } from '../../../../../topBar/constants';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
import { CardAssigneesDropdownHOC } from '../../hocs/CardAssigneesDropdownHOC/CardAssigneesDropdownHOC';
import { CARD_ASSIGNEES_TOOLTIP } from './constants';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CardAssignees`) : null;

export function CardAssignees({
    assignees,
    assigneeIds,
    authUserPermissionId,
    boardId,
    boardRoles,
    boardUsers,
    cardId,
    isReadonly,
    isTemplates,
    listId,
    source,
    onClose,
    onChange,
    onOpen,
    setOpen,
}: ICardAssigneesProps) {
    if (analyzeRender) analyzeRender.call(cardId, arguments[0]);
    const className = CARD_CLASS + '__assignees';

    const [isOpened, _setOpened] = React.useState(null);
    const [directionVertical, setDirectionVertical] = React.useState<'down' | 'up'>('down');

    const setOpened = (isOpened: boolean) => {
        _setOpened(isOpened);
        if (setOpen) setOpen(isOpened);
    };

    React.useEffect(() => {
        function onScroll() {
            setOpened(false)
        }
        if (isOpened && !isTemplates) {
            window.addEventListener('scroll', onScroll);
        }

        return () => window.removeEventListener('scroll', onScroll);
    }, [isOpened]);

    if (isReadonly && (!assignees || !assignees.length)) return null;

    if (isReadonly && assignees && assignees.length) {
        return <UsersTooltip
            className={`
                ${className}
                ${CARD_CONTROL_CLASS}
                ${assignees && assignees.length === 1 ? className + '--small' : ''}
            `}
            authUserPermissionId={authUserPermissionId}
            isBig
            roles={boardRoles}
            users={assignees}
            boardUsers={boardUsers}
        />;
    }

    return (
        <ButtonDropdown
            className={`
                ${className}
                ${CARD_CONTROL_CLASS}
                ${!assignees || !assignees.length ? className + '--empty' : ''}
                ${assignees && assignees.length === 1 ? className + '--small' : ''}
            `}
            dropdownClassName={`
                ${className + '-dropdown'}
                ${CARD_CONTROL_CLASS}
                ${CLASS_ABSTRACT_DASHBOARD_SCROLL_PREVENT}
                ${LIST_CONTROL_CLASS}
            `}
            isFitWindow
            portal
            portalId={isTemplates ? CARD_TEMPLATES_PORTAL : DEFAULT_PORTAL}
            directionHorizontal={'right'}
            opened={isOpened}
            onClose={() => {
                setTimeout(() => {
                    setOpened(false);
                }, 0);
                if (onClose) onClose();
                const topBar = document.querySelector(`.${TOP_BAR_CLASS}`) as HTMLElement;
                if (topBar) {
                    topBar.style.zIndex = '120'; // $z-fold * 1.2
                }
            }}
            onOpen={() => {
                const topBar = document.querySelector(`.${TOP_BAR_CLASS}`) as HTMLElement;
                if (topBar) {
                    topBar.style.zIndex = 'unset';
                }
                onOpen();
                setOpened(true);
            }}
            onDirectionVerticalSet={(value) => setDirectionVertical(value as 'down' | 'up')}
        >
            <Button
                variant={'icon'}
                className={className + '-button'}
                tooltip={!(assignees && assignees.length) ? CARD_ASSIGNEES_TOOLTIP : ''}
            >
                {assignees && assignees.length ?
                    <UsersTooltip
                        authUserPermissionId={authUserPermissionId}
                        isBig
                        roles={boardRoles}
                        users={assignees}
                        boardUsers={boardUsers}
                    />
                    : <Icon xlink={'user'} size={24} />
                }
            </Button>
            <CardAssigneesDropdownHOC
                assignees={assigneeIds}
                cardId={cardId}
                boardId={boardId}
                source={source}
                directionVertical={directionVertical}
                onClosed={() => setOpened(false)}
                listId={listId}
                onChange={onChange}
            />
        </ButtonDropdown>
    );
}
